<template>
  <a-form :form="form">
    <a-row :gutter="16">
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <a-form-item label="No PP">
            <a-select
            :disabled="(mode=='Create' && listUMPP.length>0) || mode=='Edit'"
              showSearch
              placeholder="Please select"
              v-decorator="['no_pp', {rules: [{required: true}], initialValue:data.no_pp}]"
              @change="handleNoPp"
            >
              <a-select-option v-for="data in um_noPP" :key="data.no_pp">{{data.no_pp}}</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="Date">
            <a-date-picker
            placeholder="Select Date"
              v-if="mode==='Edit'"
              v-decorator="['tanggal', {rules: [{required: true}],initialValue: data.tanggal ? moment(data.tanggal,defaultFormat):null}]"
              :format="dateFormatTanggal"
              disabled
            ></a-date-picker>
            <a-date-picker
              v-else
              placeholder="Select Date"
              v-decorator="['tanggal', {rules: [{required: true}],initialValue: tgl_buat}]"
              :format="dateFormatTanggal"
            ></a-date-picker>
          </a-form-item>
      </a-col>
      <a-col :xs="{span: 24}" :lg="{span:12}">
        <!-- <a-form-item label="Estimation">
            <a-input-number
              :min="0"
              class="m-width-full"
              :formatter="value => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :parser="value => value.replace(/\\s?|(,*)/g, '')"
              placeholder="Input a number"
              v-decorator="['estimasi_value', {rules: [{required: true},{validator:checkPrice}], initialValue: data.estimate_value}]"
            />
          </a-form-item> -->
          <a-form-item label="Description">
            <a-input
              v-decorator="['deskripsi', {rules: [{required: true}],initialValue: data.deskripsi}]"
            ></a-input>
          </a-form-item>

          <a-form-item label="Atasan Langsung" v-if="jenis==='Non Project'">
            <a-input
              disabled
              v-decorator="['atasan_langsung',{rules: [{required: true}], initialValue: data.atasan_langsung}]"
            ></a-input>
          </a-form-item>
          <div style="display:none">
          <a-form-item label="Vice President Finance Approval">
            <a-input
              v-decorator="['approval_bod',{rules: [{required: true}], initialValue: data.approval_bod}]"
              disabled
            ></a-input>
          </a-form-item>
          </div>
          <!-- <a-form-item label="Note">
            <a-textarea
              placeholder="Write the note here ... "
              :rows="4"
              v-decorator="['catatan', {initialValue: data.catatan}]"
            />
          </a-form-item> -->
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "Informasi",
  props: {
    id: String,
    data: {},
    mode: String,
    mata_uang: String,
    listUMPP: {},
  },
  data() {
    return {
      form: this.$form.createForm(this),
      countUm: "0",
      um_noPP: [],
      no_um: "",
      bod: "",
      //catatan: "",
      value: "",
      kurs: "",
      postData: new FormData(),
      dateFormat: "DD-MM-YYYY HH:mm:ssZ",
      dateFormatTanggal: "DD-MM-YYYY",
      defaultFormat: "YYYY-MM-DD",
      jenis: "",
      tgl_buat: "",
      end_user: "",
      atasan_langsung: "",
      btnLoading: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getKategori",
      "getActiveProject",
      "getUsedFor",
      "getAllKaryawan",
      "getDefaultDateFormat",
      "getAuth",
      "getSites"
    ]),
    initialData() {
      let informasi = {};

      if (this.data === undefined || this.data.length <= 0) {
        informasi = {
          kategori: "Project",
          id_pp: "",
          no_pp: "",
          id_supplier: "",
          tgl_buat: moment().format(this.getDefaultDateFormat),
          deskripsi: "",
          tax: 0,
          check_tax: false,
          catatan: "",
          lokasi: "",
          bod: ""
        };

        return { informasi };
      } else {

        informasi = {
          id_manifest: this.id,
          id_wo: this.data.id_wo,
          id_pp: this.data.id_pp,
          no_pp: this.data.no_pp,
          no_wo: this.data.no_wo,
          kategori: this.data.kategori,
          tgl_buat: moment(this.data.tgl_buat).format(
            this.getDefaultDateFormat
          ),
          deskripsi: this.data.deskripsi,
          tax: this.data.tax,
          check_tax: this.data.check_tax,
          catatan: this.data.catatan,
          lokasi: this.data.lokasi,
          bod: this.data.bod
        };

        return { informasi };
      }
    },
    project() {
      if (this.kategori == "Non Project") {
        return this.getActiveProject.filter(
          obj =>
            obj.kategori &&
            obj.kategori.toLowerCase().indexOf("Non Project".toLowerCase()) >= 0
        );
      } else {
        return this.getActiveProject.filter(
          obj =>
            obj.kategori &&
            obj.kategori.toLowerCase().indexOf("Non Project".toLowerCase()) ===
              -1
        );
      }
    }
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KARYAWAN");

    axios({
        method: "get",
        url: this.$serviceUrl + "um_pp/no_pp",
        params: {
          tlc: this.getAuth.username
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey
        }
      })
        .then(response => {
          this.um_noPP = response.data.data;
        })
        .catch(err => {
          this.displayMessage("error-active-pp");
          this.$router.go(-1);
        });

    if (this.id) {
      this.mode = "Edit";
          this.jenis = this.data.jenis;
          this.countUm = this.data.seq;
          this.bod = this.data.approval_bod + " - " +
            this.data.nama_bod;
          this.end_user = this.data.end_user;
          this.atasan_langsung = this.data.approval_atasan +
            " - " + this.data.nama_pimpro_atasan;
      // axios({
      //   method: "get",
      //   url: this.$serviceUrl + "um_pp/um_pp_Detil",
      //   params: {
      //     id_manifest: this.id,
      //     tlc: this.getAuth.username
      //   },
      //   auth: {
      //     username: this.getAuth.username,
      //     password: this.getAuth.password
      //   },
      //   headers: {
      //     "X-API-KEY": this.getAuth.apikey
      //   }
      // })
      //   .then(response => {
      //     this.dataDetail = response.data.detail_um_pp[0];
      //     this.jenis = response.data.detail_um_pp[0].jenis;
      //     this.countUm = response.data.detail_um_pp[0].seq;
      //     this.bod =
      //       response.data.detail_um_pp[0].approval_bod +
      //       " - " +
      //       response.data.detail_um_pp[0].nama_bod;
      //     this.end_user = response.data.detail_um_pp[0].end_user;
      //     this.atasan_langsung =
      //       response.data.detail_um_pp[0].approval_atasan +
      //       " - " +
      //       response.data.detail_um_pp[0].nama_pimpro_atasan;
      //   })
      //   .catch(err => {
      //     let responses = Object.assign({}, err.response.data);
      //       console.log(responses);
      //       this.displayMessageValue("error",responses);
      //   });
    } else {
      this.tgl_buat = moment(new Date(), this.dateFormatTanggal);
    }
  },
  methods: {
    moment,
    handleNoPp(data) {
      console.log("handleNoPp")
      let filter = this.um_noPP.filter(
        obj => obj.no_pp.toLowerCase().indexOf(data.toLowerCase()) >= 0
      );

      this.jenis = filter[0].peruntukan;
      this.bod = filter[0].bod + " - " + filter[0].nama_bod;
      this.countUm = filter[0].seq;
      this.end_user = filter[0].end_user;
      this.atasan_langsung = filter[0].atasan + " - " + filter[0].nama_atasan;
      this.kurs = filter[0].kurs;

      this.form.setFieldsValue({
        approval_bod: this.bod
      });
    },
    filterMataUang(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    save(){
      if (this.mode === "Edit") {
        this.confirmMessage("confirm-edit");
      }else{
        this.confirmMessage("confirm-save");
      }
    },
    submit() {
      if (this.mode === "Edit") {
        this.form.validateFields((err, values) => {
          if (err) {
            this.btnLoading = false;
            return;
          }

          this.btnLoading = true;

          axios({
            method: "put",
            url: this.$serviceUrl + "um_pp",

            data: {
              tlc: this.getAuth.username,
              id_manifest: this.id,
              deskripsi: values.deskripsi,
              end_user: this.end_user,
              kurs_to_idr: values.kurs,
              estimate_value: values.estimasi_value,
              catatan: values.catatan !==undefined ? values.catatan : ""
            },
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password
            },
            headers: {
              "Content-Type": "application/json",
              "X-API-KEY": this.getAuth.apikey
            }
          })
            .then(response => {
              this.displayMessage("success-edit");
              this.btnLoading = false;
              this.$router.push({ name: "ListUmPp" });
            })
            .catch(err => {
              let responses = Object.assign({}, err.response.data);
            console.log(responses);
            this.displayMessageValue("error",responses);
              this.btnLoading = false;
            });
        });
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.btnLoading = false;
            return;
          }

          this.btnLoading = true;

          this.postData = new FormData();
          this.postData.append("tlc", this.getAuth.username);
          this.postData.append("no_pp", values.no_pp);
          this.postData.append(
            "tanggal",
            moment(values.tanggal).format(this.defaultFormat)
          );
          this.postData.append("deskripsi", values.deskripsi);
          this.postData.append("end_user", this.end_user);
          this.postData.append("value_um", values.estimasi_value);
          //this.postData.append("catatan", values.catatan !==undefined ? values.catatan : "");
          this.postData.append(
            "approval_bod",
            values.approval_bod.split("-")[0].trim()
          );

          axios({
            method: "post",
            url: this.$serviceUrl + "um_pp",
            data: this.postData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey
            }
          })
            .then(response => {
              this.displayMessage("success-save");
              this.btnLoading = false;
              this.$router.push({ name: "ListUmPp" });
            })
            .catch(err => {
              if (
                err.response.data.message === "Permintaan melebihi saldo PP!"
              ) {
                this.displayMessage("error-saldopp");
              } else {
                GlobalMethod.methods.redirectPandapaKita(
                  this,
                  err.response.data.error
                );
              }
              this.btnLoading = false;
            });
        });
      }
    },
    batal() {
      this.$router.push({ name: "ListUmPp" });
    },
    checkPrice(rule, value, callback) {
      if (value > 0) {
        callback();
        return;
      }
      callback("Price must greater than zero!");
    },
    handleKategori(e) {
      this.initialData.informasi.kategori = e.target.value;
      this.kategori = e.target.value;
    },
    handleProject(value) {
      let filter = this.project.filter(
        obj => obj.kode_project.toLowerCase().indexOf(value.toLowerCase()) >= 0
      );

      return filter;
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.form.resetFields()
          this.displayMessage("form-warning");
          return;
        }

        let id_pp = _.filter(this.um_noPP, {
          no_pp: values.no_pp
        });

        values.end_user = this.end_user;
        values.catatan = this.data.catatan;
        if (this.mode === "Edit") {
          values.id_pp = this.data.id_pp;
          values.id_manifest = this.id;
          values.approval_bod = this.data.approval_bod
          values.end_user = this.data.end_user
          values.currency = this.data.mata_uang
          values.no_pp = this.data.no_pp
          values.no_um = this.data.no_um
          values.seq = this.data.seq
        } else {
          values.id_pp = id_pp[0].id_pp;
          values.kurs = id_pp[0].kurs;
          values.currency = id_pp[0].currency;
        }

        let dataValues = {
          ...values,
          tgl_buat: moment(values.tgl_buat).format(this.getStandartFormatDate)
        };

        Event.$emit("umppData", {
          informasi: dataValues,
          mata_uang: this.mata_uang ? this.mata_uang : this.currency
        });
      });
    },
    handleSupplier(idSpl) {
      this.initialData.informasi.id_supplier = idSpl.id_supplier;
      if (this.mode === "Edit") {
        this.data.id_supplier = idSpl.id_supplier;
      }
      this.form.setFieldsValue({ id_supplier: idSpl.nm_supplier });
    },
    handleBOD(data) {
      let filter = this.wo_bod.filter(
        obj => obj.tlc.toLowerCase().indexOf(data.toLowerCase()) >= 0
      );

      return filter;
    },
    handleTax(e) {
      this.initialData.informasi.check_tax = e.target.checked;
      if (this.initialData.informasi.check_tax) {
        this.form.setFieldsValue({ tax: "10" });
      } else {
        this.form.setFieldsValue({ tax: "0" });
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    }
  }
};
</script>

<style>
</style>